import { useQuery } from '@tanstack/react-query';
import { fetchLocalizingList } from 'apis/common/commonApis';
import { useTranslation } from 'react-i18next';
import { IDropListProps } from 'utils/types/common';
/**
 * * 언어 선택 드롭다운용 데이터
 */
function useLocalizingDropList() {
  const { t } = useTranslation();
  const { status, data, error, isFetching } = useQuery(
    ['localizingData'],
    async () => await fetchLocalizingList(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: t(`dbLngList.${i}.code_name`),
          }),
        );
        // newArr.push({ key: newArr?.length, value: -1, text: '없음' });
        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useLocalizingDropList;
